export const textContentCardsStandaloneGql = /* GraphQL */ `
... on landingPageContent2023_textContentCardsStandalone_BlockType {
    typeHandle
    eyebrow
    header
    description
    textAlign
    cardTheme
    roundedCorners
    colors
    imageDisplay:cardImageDisplay
    imageVariant:cardImageVariant
    cards:lp2TCCards {
        ... on lp2TCCards_BlockType {
            links:lp2TCCardLinks
            description:lp2TCDescription
            eyebrow:lp2TCEyebrow
            title:lp2TCTitle
            textAlign:lp2TCTextAlign
            image:lp2TCImage {
                ... on images_Asset {
                    title
                    sources:galleryEnlarged {
                        srcWebp
                        srcset
                    }
                    uncroppedSources:uncropped1920w {
                        srcWebp
                        srcset
                    }
                }
            }
        }
    }
}`;